import { newColors } from "constants/newColors";
import styled from "styled-components";
import { Cross } from "@styled-icons/entypo/Cross";

export const StyledSubjectManagementContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-inline: 1rem;
  box-sizing: border-box;
`;

export const StyledHeadline = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1.5rem;
  box-sizing: border-box;
  height: 50px;
`;

export const StyledButtonArea = styled.div`
  display: flex;
  align-items: center;
  column-gap: 1rem;
`;

export const StyledFilterArea = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 1rem;
  column-gap: 1rem;
  padding-bottom: 1rem;
  box-sizing: border-box;
  min-height: max-content;
`;

export const StyledCross = styled(Cross)`
  width: 0.9em;
  margin-left: 0.5em;
`;

export const StyledUl = styled.ul`
  display: flex;
  align-items: center;
  padding: 0.5em 1em;
  box-sizing: border-box;
  min-height: 55px;
  border-radius: 5px;
  background: ${newColors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
`;

export const StyledLi = styled.li`
  display: flex;
`;

export const StyledGroupFilter = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
  padding: 0.5em 1em;
  box-sizing: border-box;
  min-height: 55px;
  border-radius: 5px;
  background: ${newColors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
`;

export const StyledSubjectListWrapper = styled.div`
  min-height: 200px;
  flex-grow: 1;
`;
